import { render, staticRenderFns } from "./CampaignsList.vue?vue&type=template&id=367c79d9&scoped=true&"
import script from "./CampaignsList.vue?vue&type=script&lang=ts&"
export * from "./CampaignsList.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignsList.vue?vue&type=style&index=0&id=367c79d9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367c79d9",
  null
  
)

export default component.exports